/* eslint-disable no-underscore-dangle */
import { API_EVENTS, REVENUE_CATEGORIES_EVENTS } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  data: [],
  error: null,
};

const revenueCategoriesReducer = (state, { type, payload }) => {
  switch (type) {
    case API_EVENTS.REQUEST:
    case REVENUE_CATEGORIES_EVENTS.ADD_REQUEST:
    case REVENUE_CATEGORIES_EVENTS.REMOVE_REQUEST:
      return { ...state, loading: true };

    case API_EVENTS.FAIL:
    case REVENUE_CATEGORIES_EVENTS.ADD_FAIL:
    case REVENUE_CATEGORIES_EVENTS.REMOVE_FAIL:
      return { ...state, loading: false, error: payload };

    case API_EVENTS.SUCCESS:
      return { ...state, loading: false, data: payload };

    case REVENUE_CATEGORIES_EVENTS.ADD_SUCCESS:
      return { ...state, loading: false, data: [...state.data, payload] };

    case REVENUE_CATEGORIES_EVENTS.REMOVE_SUCCESS:
      return { ...state, loading: false, data: state.data.filter((x) => x._id !== payload) };

    case API_EVENTS.RESET:
      return initialState;

    default:
      return state;
  }
};

export default revenueCategoriesReducer;
